// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SlideInFromTheSideModal__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Modal/SlideInFromTheSideModal.scss
 ** module id = 924
 ** module chunks = 1
 **/